import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-auth-modal-shell',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './auth-modal-shell.component.html',
  styleUrls: ['./auth-modal-shell.component.scss'],
})
export class AuthModalShellComponent {
  @Input({ required: true }) title!: string;
  @Input() showCloseButton = false;
  @Input() closeOnBackdropClick = true;

  @Output() closed = new EventEmitter<void>();

  onBackdropClick(): void {
    if (this.closeOnBackdropClick) {
      this.closed.emit();
    }
  }

  onCloseClick(): void {
    this.closed.emit();
  }
}
